<template>
  <div class="settings">
    <h1>{{ $t("langcfg.txtTopography") }}</h1>
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item :title="`${$t('langcfg.txtRvalues')} - (${rhrvTitle})`" name="rValue">
        <div class="sub-settings">
          <el-button @click="selectRhRv(true)"><span :class="rhrvClass">Rh / Rv</span></el-button>
        </div>
        <div class="sub-settings">
          <el-button @click="selectRhRv(false)" :class="rfrsClass"
            ><span :class="rfrsClass">Rf / Rs</span></el-button
          >
        </div>
      </el-collapse-item>
      <el-collapse-item
        :title="`${$t('langcfg.txtFormFactor')} - ${formFactorTitle}`"
        name="formFactor"
      >
        <div style="width: 100%; height: 100%; display: inline-flex">
          <div class="div-split">
            <div class="sub-settings">
              <el-button @click="selectMedianMode(0)"
                ><span :class="getMedianModeClass(0)">ecc</span></el-button
              >
            </div>
            <div class="sub-settings">
              <el-button @click="selectMedianMode(1)"
                ><span :class="getMedianModeClass(1)">E-val</span></el-button
              >
            </div>
            <div class="sub-settings">
              <el-button @click="selectMedianMode(2)"
                ><span :class="getMedianModeClass(2)">P-val</span></el-button
              >
            </div>
            <div class="sub-settings">
              <el-button @click="selectMedianMode(3)" :class="getMedianModeClass(3)"
                ><span :class="getMedianModeClass(3)">Q-val</span></el-button
              >
            </div>
          </div>
          <div style="width: 70px; border-right: 1px solid gray"></div>
          <div class="div-split" style="margin-left: 50px">
            <div class="sub-settings" v-for="id2 in 4" :key="id2">
              <el-button @click="selectMM(id2 + 1)"
                ><span :class="getMMClass(id2 + 1)">{{ id2 + 1 }} mm</span></el-button
              >
            </div>
          </div>
          <div class="div-split" style="margin-left: 50px">
            <div class="sub-settings" v-for="id2 in 4" :key="id2">
              <el-button @click="selectMM(id2 + 5)"
                ><span :class="getMMClass(id2 + 5)"> {{ id2 + 5 }} mm</span></el-button
              >
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        :title="`${$t('langcfg.txtCoordinate')} - (${coordinateTitle})`"
        name="coordinate"
      >
        <div class="sub-settings">
          <el-button @click="selectCartesian(true)"
            ><span :class="cartesianClass">{{
              $t("langcfg.txtCartesianCoordinate")
            }}</span></el-button
          >
        </div>
        <div class="sub-settings">
          <el-button @click="selectCartesian(false)" :class="polorClass"
            ><span :class="polorClass">{{ $t("langcfg.txtPolarCoordinate") }}</span></el-button
          >
        </div>
      </el-collapse-item>
      <el-collapse-item
        :title="`${$t('langcfg.txtMapScale')} - (${mapScaleTitle})`"
        name="mapScale"
      >
        <div class="sub-settings">
          <el-button @click="selectMapScale(true)"
            ><span :class="diaClass">{{ $t("langcfg.txtDia") }}</span></el-button
          >
        </div>
        <div class="sub-settings">
          <el-button @click="selectMapScale(false)" :class="radiusClass"
            ><span :class="radiusClass">{{ $t("langcfg.txtRadius") }}</span></el-button
          >
        </div>
      </el-collapse-item>
      <el-collapse-item
        :title="`${$t('langcfg.txtDisplaySimulatedData')} - (${fitShownTitle})`"
        name="fitShown"
      >
        <div class="sub-settings">
          <el-button @click="selectFitDataShown(true)"
            ><span :class="fitOnClass">{{ $t("langcfg.txtOpen") }}</span></el-button
          >
        </div>
        <div class="sub-settings">
          <el-button @click="selectFitDataShown(false)"
            ><span :class="fitOffClass">{{ $t("langcfg.txtClose") }}</span></el-button
          >
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { MAJMEDIANMODES } from "../../../shared/consts";
import { mapGetters, mapActions, mapState } from "vuex";
import { saveDataShowSettings } from "../../../settings";
import EVENTS from "../../../bus";
import home from "../../../store/modules/home";
let _activeName = "rValue";
const { ipcRenderer } = window.require("electron");
export default {
  name: "Topography",
  data() {
    return {
      activeName: "rValue"
    };
  },
  created() {
    this.activeName = _activeName;
  },
  methods: {
    ...mapActions({
      dataShowSettingsChanged: "topography/dataShowSettingsChanged"
    }),
    getMedianModeClass(mode) {
      return mode === this.dataShowSettings.medianMode ? "selected" : "no-selected";
    },
    getMMClass(mm) {
      return mm === this.dataShowSettings.mm ? "selected" : "no-selected";
    },
    selectMedianMode(val) {
      this.dataShowSettings.medianMode = val;
      this.dataShowSettingsChanged(this.dataShowSettings);
      //  11
      this.sendChangeStatus();
    },
    selectMM(val) {
      this.dataShowSettings.mm = val;
      this.dataShowSettingsChanged(this.dataShowSettings);
      //  11
      this.sendChangeStatus();
    },
    selectRhRv(val) {
      this.dataShowSettings.isRhRv = val;
      this.dataShowSettingsChanged(this.dataShowSettings);
      //  11
      this.sendChangeStatus();
    },
    selectCartesian(val) {
      this.dataShowSettings.isCartesian = val;
      this.dataShowSettingsChanged(this.dataShowSettings);
      this.$bus.$emit("CHANGECOORDINATESYSTEM", val);
      // /
      this.sendChangeStatus();
    },
    selectMapScale(val) {
      this.dataShowSettings.isDiameter = val;
      this.dataShowSettingsChanged(this.dataShowSettings);
      // /
      this.sendChangeStatus();
    },
    selectFitDataShown(val) {
      this.dataShowSettings.showFitData = val;
      this.dataShowSettingsChanged(this.dataShowSettings);
      this.sendChangeStatus();
    },
    // /
    sendChangeStatus() {
      let send = null;
      if (this.isHasUrl) {
        send = "sendSetMsg2";
      } else {
        send = "sendSetMsg";
      }
      ipcRenderer.send(send, {
        type: "setMainFaceTopography",
        dataShowSettings: this.dataShowSettings
      });
    },
    // /
    watchSetStatus() {
      let _this = this;
      this.$bus.$on(EVENTS.setTopo, function (msg) {
        _this.dataShowSettingsChanged(msg.dataShowSettings);
      });
    }
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.setTopo);
  },
  mounted() {
    this.watchSetStatus();
  },
  watch: {
    activeName: function () {
      _activeName = this.activeName;
    },
    dataShowSettings: {
      handler: function (val) {
        saveDataShowSettings(val);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["dataShowSettings"]),
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    }),
    rhrvClass() {
      return this.dataShowSettings.isRhRv ? "selected" : "no-selected";
    },
    rfrsClass() {
      return !this.dataShowSettings.isRhRv ? "selected" : "no-selected";
    },
    cartesianClass() {
      return this.dataShowSettings.isCartesian ? "selected" : "no-selected";
    },
    polorClass() {
      return !this.dataShowSettings.isCartesian ? "selected" : "no-selected";
    },
    diaClass() {
      return this.dataShowSettings.isDiameter ? "selected" : "no-selected";
    },
    radiusClass() {
      return !this.dataShowSettings.isDiameter ? "selected" : "no-selected";
    },
    fitOnClass() {
      return this.dataShowSettings.showFitData ? "selected" : "no-selected";
    },
    fitOffClass() {
      return !this.dataShowSettings.showFitData ? "selected" : "no-selected";
    },
    rhrvTitle() {
      return this.dataShowSettings.isRhRv ? "Rh / Rv" : "Rf / Rs";
    },
    formFactorTitle() {
      let set = this.dataShowSettings;
      return `(${MAJMEDIANMODES[set.medianMode]}, ${set.mm} mm)`;
    },
    coordinateTitle() {
      return this.dataShowSettings.isCartesian
        ? this.$t("langcfg.txtCartesianCoordinate")
        : this.$t("langcfg.txtPolarCoordinate");
    },
    mapScaleTitle() {
      return this.dataShowSettings.isDiameter
        ? this.$t("langcfg.txtDia")
        : this.$t("langcfg.txtRadius");
    },
    fitShownTitle() {
      return this.dataShowSettings.showFitData
        ? this.$t("langcfg.txtOpen")
        : this.$t("langcfg.txtClose");
    }
  }
};
</script>
<style lang="less" scoped>
.el-collapse {
  border: none;
  padding: 10px;
  padding-top: 30px;
  padding-left: 30px;
}
.el-collapse-item {
  margin-bottom: 20px;
}
.el-collapse /deep/ .el-collapse-item__content,
.el-collapse /deep/ .el-collapse-item__wrap {
  padding: 0px;
  border: none;
}
.el-collapse /deep/ .el-collapse-item__header {
  font-size: 28px;
  background: #2d3039;
  border: none;
  color: white;
}
.sub-settings {
  font-size: 25px;
  background: #2d3039;
  color: white;
  padding-top: 15px;
}
.settings {
  margin-top: 60px;
  margin-left: 60px;
  font-size: 23px;
  display: flex;
  align-items: left;
  background: #2d3039;
  flex-direction: column;
}
.el-collapse /deep/ .el-collapse-item__wrap {
  background: #2d3039;
}
.el-button {
  background: #2d3039;
  border: none;
  width: 100%;
  height: 100%;
  font-size: 30px;
  color: white;
  text-align: left;
  padding-left: 40px;
}
.selected {
  color: @blue-selected-color;
}
.no-selected {
  color: white;
}
.div-split {
  width: 33.333%;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Topography.vue